export default __webpack_public_path__ + "static/media/message-read.573b8c8c.svg";